import { initializeClientEnv } from "@repo/db/env/client"
// This file must be imported before any other files that use @repo/db
import { clientEnv } from "@repo/env/vite"

// Initialize the client environment for @repo/db
initializeClientEnv({
  CONVEX_SITE_URL: clientEnv.CONVEX_SITE_URL,
  CONVEX_URL: clientEnv.CONVEX_URL,
})

// Re-export env for convenience
export { clientEnv }
